import { Pipe, PipeTransform } from '@angular/core';
import { StringHelper } from '../helpers/string-helper';

@Pipe({
  name: 'shortenText'
})
export class ShortenTextPipe implements PipeTransform {
  transform(value: any, length = 30) {
    return StringHelper.shortenText(value, length);
  }
}
